<style scoped>
    .loading-spinner-overlay {
        display: flex;
        justify-content: center;
        align-items: center;
        background: white;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
</style>

<template>
    <div v-if="loading" class="loading-spinner-overlay">
        <clip-loader :loading="loading" color="gray" size="45px"></clip-loader>
    </div>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader';

export default {
    components : {"clip-loader" : ClipLoader},

    props : {

        loading : {
            type : Boolean,
            default : false,
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/LoadingSpinner.vue